var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconNonSyncDevice = function SvgIconNonSyncDevice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16 - Non-Sync / device / non-synce device-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1406 3.26192C2.04987 3.49028 2 3.73932 2 4V10C2 11.1046 2.89543 12 4 12H7.25V13.25H4.5C4.08579 13.25 3.75 13.5858 3.75 14C3.75 14.4142 4.08579 14.75 4.5 14.75H8H11.5C11.9142 14.75 12.25 14.4142 12.25 14C12.25 13.5858 11.9142 13.25 11.5 13.25H8.75V12H10.8787L9.37868 10.5H4C3.72386 10.5 3.5 10.2761 3.5 10V4.62132L2.1406 3.26192ZM12.5 9.37868V4C12.5 3.72386 12.2761 3.5 12 3.5H6.62132L5.12132 2H12C13.1046 2 14 2.89543 14 4V10C14 10.2607 13.9501 10.5097 13.8594 10.7381L12.5 9.37868Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 470",
    d: "M3 2L13 12",
    stroke: "#15141A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconNonSyncDevice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-non-sync-device.dfcd7ea06ef28af9e9a1b0799b4abb91.svg";